// axiosConfig.ts
import axios from 'axios';

const createAxiosInstance = (CDN: boolean) => {
  return axios.create({
    baseURL: CDN ? process.env.REACT_APP_CDN_URL : process.env.REACT_APP_USER_API_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export default createAxiosInstance;
